import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'StatusPage.title',
    defaultMessage: 'Withdrawal sent',
    description: 'Page title displayed after a withdrawal has been sent',
  },
  description: {
    id: 'StatusPage.description',
    defaultMessage: `Your transactions were submitted. They may take a few minutes to be confirmed onchain.`,
    description:
      'Text displayed to the user after a withdrawal has been submitted, explaining that confirmation may take a few minutes',
  },
  failuresPresentBannerTitle: {
    id: 'StatusPage.failuresPresentBannerTitle',
    defaultMessage: "We couldn't process some of your assets",
    description: 'Banner title explaining that some transactions failed',
  },
  failuresPresentBannerBody: {
    id: 'StatusPage.failuresPresentBannerBody',
    defaultMessage:
      "Something went wrong and some of your assets were not withdrawn. Please wait 30 minutes and try again. If that doesn't work, please reach out to our support team for help.",
    description: 'Message explaining that some transactions failed',
  },
  failuresPresentBannerAction: {
    id: 'StatusPage.failuresPresentBannerAction',
    defaultMessage: 'Try again',
    description: 'Button to try the whole process over again from the beginning',
  },
  allWithdrawalsComplete: {
    id: 'StatusPage.allWithdrawalsComplete',
    defaultMessage: 'All withdrawals complete',
    description: 'Message indicating that all withdrawals are done',
  },
  processingWithdrawals: {
    id: 'StatusPage.processingWithdrawals',
    defaultMessage: 'Processing withdrawals...',
    description: 'Message indicating that some withdrawals are still pending',
  },
  someWithdrawalsFailed: {
    id: 'StatusPage.someWithdrawalsFailed',
    defaultMessage: 'Some withdrawals failed',
    description: 'Message indicating that some withdrawals failed',
  },
  transactionHash: {
    id: 'StatusPage.transactionHash',
    defaultMessage: 'Transaction Hash',
    description:
      'Header text for the column in the transaction table that displays the transaction hash',
  },
  value: {
    id: 'StatusPage.value',
    defaultMessage: 'Value',
    description:
      'Header text for the column in the transaction table that displays the transaction value',
  },
  status: {
    id: 'StatusPage.status',
    defaultMessage: 'Status',
    description:
      'Header text for the column in the transaction table that displays the transaction status',
  },
  success: {
    id: 'StatusPage.success',
    defaultMessage: 'Success',
    description: 'Indicates that transactions all succeeded',
  },
  error: {
    id: 'StatusPage.error',
    defaultMessage: 'Error',
    description: 'Indicates that at least one transaction failed',
  },
  pending: {
    id: 'StatusPage.error',
    defaultMessage: 'Pending...',
    description: 'Indicates that at least one transaction is still pending',
  },
  someTransactionsFailedTooltip: {
    id: 'StatusPage.totalInvalidTooltip',
    defaultMessage: 'Some transactions for this currency were not successful',
    description: 'Tooltip explaining that some transactions failed',
  },
  totalProceeds: {
    id: 'StatusPage.totalProceeds',
    defaultMessage: 'Total proceeds',
    description: 'Label for the total proceeds from the transactions',
  },
  totalEstimatedProceedsTooltip: {
    id: 'StatusPage.totalEstimatedProceedsTooltip',
    defaultMessage: 'Total estimated proceeds from all non-failed transactions',
    description: 'Tooltip for the total estimated proceeds from all non-failed transactions',
  },
});
